import { default as __nuxt_component_0 } from "/opt/build/repo/components/Common/TokenIcon.vue";
import { default as __nuxt_component_1 } from "/opt/build/repo/components/Partials/Trading/Form/CancelButton.vue";
import { default as __nuxt_component_2 } from "/opt/build/repo/node_modules/nuxt/dist/app/components/nuxt-link";
import { default as __nuxt_component_3 } from "/opt/build/repo/components/App/Number/Index.vue";
import { default as __nuxt_component_4 } from "/opt/build/repo/components/Common/Table/Row.vue";
"use strict";
import { defineComponent as _defineComponent } from "vue";
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "flex items-center justify-between text-xs leading-5" };
const _hoisted_2 = { class: "flex items-center gap-1" };
const _hoisted_3 = { key: 0 };
const _hoisted_4 = { class: "text-gray-200 font-semibold" };
const _hoisted_5 = {
  key: 1,
  class: "font-mono"
};
const _hoisted_6 = {
  key: 0,
  class: "mt-0.5 text-gray-500 uppercase tracking-widest text-2xs"
};
const _hoisted_7 = { class: "text-gray-500 uppercase tracking-widest text-3xs" };
const _hoisted_8 = { class: "text-right" };
const _hoisted_9 = { class: "text-gray-500 uppercase tracking-widest text-3xs" };
const _hoisted_10 = { class: "flex items-center gap-1 justify-end" };
const _hoisted_11 = /* @__PURE__ */ _createElementVNode("span", null, "/", -1);
const _hoisted_12 = { class: "text-gray-500 uppercase tracking-widest text-3xs" };
const _hoisted_13 = { class: "text-right" };
const _hoisted_14 = { class: "text-2xs text-gray-500" };
import { Status } from "@injectivelabs/utils";
import {
  DerivativeOrderSide
} from "@injectivelabs/sdk-ui-ts";
import { getMarketRoute } from "@/app/utils/market";
export default /* @__PURE__ */ _defineComponent({
  __name: "Mobile",
  props: {
    isSpot: Boolean,
    order: {
      required: true,
      type: Object
    }
  },
  setup(__props) {
    const props = __props;
    const spotStore = useSpotStore();
    const derivativeStore = useDerivativeStore();
    const { t } = useLang();
    const { $onError } = useNuxtApp();
    const { success } = useNotifications();
    const status = reactive(new Status());
    const {
      price,
      total,
      market,
      quantity,
      leverage,
      isReduceOnly,
      orderFillable,
      priceDecimals,
      filledQuantity,
      quantityDecimals
    } = useOrder(
      computed(() => props.order),
      computed(() => props.isSpot)
    );
    const marketRoute = computed(() => {
      if (!market.value) {
        return void 0;
      }
      return getMarketRoute(market.value);
    });
    function onCancelOrder() {
      status.setLoading();
      const action = props.isSpot ? () => spotStore.cancelOrder(props.order) : () => derivativeStore.cancelOrder(props.order);
      action().then(() => {
        success({ title: t("trade.order_success_canceling") });
      }).catch($onError).finally(() => {
        status.setIdle();
      });
    }
    return (_ctx, _cache) => {
      const _component_CommonTokenIcon = __nuxt_component_0;
      const _component_PartialsTradingFormCancelButton = __nuxt_component_1;
      const _component_NuxtLink = __nuxt_component_2;
      const _component_AppNumber = __nuxt_component_3;
      const _component_CommonTableRow = __nuxt_component_4;
      return _unref(market) ? (_openBlock(), _createBlock(_component_CommonTableRow, {
        key: 0,
        dense: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_NuxtLink, {
            class: "pb-1 col-span-2",
            to: _unref(marketRoute)
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("span", {
                    class: _normalizeClass({
                      "text-green-500": __props.order.orderSide === _unref(DerivativeOrderSide).Buy,
                      "text-red-500": __props.order.orderSide === _unref(DerivativeOrderSide).Sell
                    })
                  }, _toDisplayString(__props.order.orderSide === _unref(DerivativeOrderSide).Buy ? _ctx.$t("trade.buy") : _ctx.$t("trade.sell")), 3),
                  _unref(market).baseToken ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_CommonTokenIcon, {
                      token: _unref(market).baseToken,
                      md: ""
                    }, null, 8, ["token"])
                  ])) : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(market).ticker), 1),
                  _unref(leverage).gte(0) ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(leverage).toFormat(2)) + "x ", 1)) : _createCommentVNode("", true)
                ]),
                _unref(orderFillable) ? (_openBlock(), _createBlock(_component_PartialsTradingFormCancelButton, {
                  key: 0,
                  status: _unref(status),
                  sm: "",
                  onClick: onCancelOrder
                }, null, 8, ["status"])) : _createCommentVNode("", true)
              ]),
              _unref(isReduceOnly) ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t("trade.reduce_only")), 1)) : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["to"]),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("trade.price")), 1),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_AppNumber, {
              decimals: _unref(priceDecimals),
              number: _unref(price)
            }, null, 8, ["decimals", "number"])
          ]),
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("trade.filled")) + " / " + _toDisplayString(_ctx.$t("trade.amount")), 1),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_AppNumber, {
              decimals: _unref(quantityDecimals),
              number: _unref(filledQuantity)
            }, null, 8, ["decimals", "number"]),
            _hoisted_11,
            _createVNode(_component_AppNumber, {
              decimals: _unref(quantityDecimals),
              number: _unref(quantity)
            }, null, 8, ["decimals", "number"])
          ]),
          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t("trade.total")), 1),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_AppNumber, {
              decimals: _unref(priceDecimals),
              number: _unref(total)
            }, {
              addon: _withCtx(() => [
                _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(market).quoteToken.symbol), 1)
              ]),
              _: 1
            }, 8, ["decimals", "number"])
          ])
        ]),
        _: 1
      })) : _createCommentVNode("", true);
    };
  }
});
